import ReportForm from "./ReportForm";
import { ReportPostType } from "../../types/Report";
import { postReport } from "../../fetch/fetch.report";
import { useContext } from "react";
import { SubmitContext } from "../../context/context.submit";
import ConditionalButton from "../core/ConditionalButton";
import Show from "../core/Show";
import ErrMessage from "../core/ErrMessage";

const ReportPost = ({
  userId,
  itemId,
  context,
}: {
  userId?: string;
  itemId?: string;
  context?: string;
}) => {
  const { loading, error, buttonElem, setError } = useContext(SubmitContext);
  const onSubmit = async (data: ReportPostType) => {
    const res = await postReport(data);
    if (res.error) {
      setError(res.error);
      return;
    }
  };

  return (
    <ReportForm
      onSubmit={onSubmit}
      userId={userId}
      itemId={itemId}
      title={context}
      description={context}
    >
      <ConditionalButton
        className="btn btn-primary w-full"
        classNameLoading="btn btn-ghost skeleton w-full"
        isLoading={loading}
        whenLoading={buttonElem}
        type="submit"
      >
        {buttonElem}
      </ConditionalButton>
      <Show condition={Boolean(error)}>
        <ErrMessage message={String(error)} />
      </Show>
    </ReportForm>
  );
};
export default ReportPost;
